import { render, staticRenderFns } from "./posTransactionDetails.vue?vue&type=template&id=7f88daa9&"
import script from "./posTransactionDetails.vue?vue&type=script&lang=js&"
export * from "./posTransactionDetails.vue?vue&type=script&lang=js&"
import style0 from "./posTransactionDetails.vue?vue&type=style&index=0&id=7f88daa9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports